module.exports = __webpack_public_path__ + "img/img_prduct_content1.45068cb1.svg";